import { getPublishedInsights } from "../../data/insights";

export const slugify = (value = "") =>
  String(value)
    .toLowerCase()
    .trim()
    .replace(/['"]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const formatInsightDate = (value) => {
  if (!value) return "";
  const date = new Date(`${value}T00:00:00Z`);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

export const formatInsightTimestamp = (value) => {
  if (!value) return "";
  const date = new Date(`${value}T00:00:00Z`);
  if (Number.isNaN(date.getTime())) return value;
  return date.toISOString();
};

export const joinKeywords = (keywords = []) => keywords.filter(Boolean).join(", ");

export const toCsvList = (value = "") =>
  String(value)
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);

export const toInsightArray = (value = "") =>
  String(value)
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);

export const parseInsightSections = (value) => {
  if (Array.isArray(value)) return value;
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    return [];
  }
};

export const stringifyInsightSections = (sections = []) => JSON.stringify(sections, null, 2);

export const normalizeInsightSections = (sections = []) =>
  sections
    .filter(Boolean)
    .map((section) => ({
      heading: section.heading || "",
      paragraphs: Array.isArray(section.paragraphs)
        ? section.paragraphs.filter(Boolean)
        : toCsvList(section.paragraphs || ""),
      bullets: Array.isArray(section.bullets)
        ? section.bullets.filter(Boolean)
        : toCsvList(section.bullets || ""),
    }))
    .filter((section) => section.heading || section.paragraphs.length || section.bullets.length);

export const calcSeoCompleteness = (post) => {
  const checks = [
    post.title,
    post.subtitle,
    post.excerpt,
    post.category,
    post.tags && post.tags.length,
    post.authorName,
    post.publishDate,
    post.readingTime,
    post.heroImage,
    post.metaTitle,
    post.metaDescription,
    post.canonicalUrl,
    post.ogTitle,
    post.ogDescription,
    post.ogImage,
    post.twitterTitle,
    post.twitterDescription,
    post.keywords && post.keywords.length,
  ];
  const completed = checks.filter(Boolean).length;
  const percent = Math.round((completed / checks.length) * 100);
  const missing = [];
  const labels = [
    "title",
    "subtitle",
    "excerpt",
    "category",
    "tags",
    "author name",
    "publish date",
    "reading time",
    "hero image",
    "meta title",
    "meta description",
    "canonical url",
    "og title",
    "og description",
    "og image",
    "twitter title",
    "twitter description",
    "keywords",
  ];

  checks.forEach((check, index) => {
    if (!check) missing.push(labels[index]);
  });

  return { percent, missing };
};

export const getPublishedCount = () => getPublishedInsights().length;

